import { Image } from "antd";
import React from "react";
import NoDataImage from "../../assets/images/content/no_data.png";
import { P2, P3 } from "../NormalFonts";
import { NoDataProps } from "./data";
import styles from "./styles.module.scss";

export const NoData: React.FC<NoDataProps> = ({
  title,
  subtitle,
  showImage = true,
  offsetTop = 0,
  additionalItem,
}) => {
  return (
    <div
      className={styles.noDataContainer}
      style={{ marginTop: `${offsetTop}px` }}
    >
      {showImage === true ? <Image preview={false} src={NoDataImage} /> : null}
      <P2 weight="medium" color="#1C222B">
        {title}
      </P2>
      <P3 color="#5E718D">{subtitle}</P3>
      {additionalItem ? additionalItem : null}
    </div>
  );
};
